export default __webpack_public_path__ + "static/media/flussseeschwalbe.ad0308f6.jpg";